import React, { useState, useEffect } from 'react'
import { Row, Col, Image, Typography, Switch, Tabs } from 'antd'
import { prUrl } from '../config.js'
import { translate } from '../../utils'
import PropertyTable from './PropertyTable.jsx';
import axios from 'axios';

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const InfoCard = (props) => {
	const [transed, setTransed] = useState(false)
	const [loading, setLoading] = useState(false)
	const [transText, setTransText] = useState('')
	const [wiki, setWiki] = useState({})

	const setTransResult = (t) => {
		setTransed(true)
		setLoading(false)
		setTransText(t)
	}

	const trans = () => {
		if (!transed) {
			setLoading(true)
			translate(props.showItem.content, setTransResult)
		} else {
			setTransed(false)
			setLoading(false)
		}
	}

	useEffect(()=>{
		setWiki({})
		const { showItem } = props;
		if (showItem.id && showItem.id[0] === 'Q') {
			if (showItem.wikiNode && Object.keys(showItem.wikiNode).length>0){
				setWiki(showItem.wikiNode)
			}else{
				axios.get(`https://www.osintsee.com/wiki?content=n&qcode=${showItem.id}`).then(
					response => {
						if (response.data && response.data.wikipedia && response.data.wikipedia.length > 0) {
							setWiki(response.data.wikipedia[0])
							props.saveWiki(showItem.id, response.data.wikipedia[0])
						}
					},
					error => { console.log("error", error) }
				)
			}			
		}
	},[props.showItem])

	const { showItem } = props;
	// console.log(wiki);
	return (
		Object.keys(showItem).length>0 ?
			<Tabs key={showItem.id} defaultActiveKey={'1'}>
				<TabPane key={1} tab={showItem.id.includes("-")?'关系属性':'节点属性'}>
					<PropertyTable id={showItem.id} pcode={showItem.pcode?showItem.pcode:''} showItem={showItem.properties} 
						saveProperties={props.saveProperties}/>						
				</TabPane>
				{
					Object.keys(wiki).length>0 ?
					<TabPane key={2} tab={'维基百科'}>						
						<Row align='top' justify='center'>
							<Col span={wiki.encryptedImageUrl ? 8 : 0} >
								{wiki.encryptedImageUrl && <Image src={prUrl + wiki.encryptedImageUrl} preview={false} height={'28vh'} style={{'objectFit':'contain'}} />}
							</Col>
							<Col span={wiki.encryptedImageUrl ? 15 : 24} offset={wiki.encryptedImageUrl ? 1 : 0}>
								<Title level={4} style={{ textAlign: 'center' }}><a href={prUrl + wiki.encryptedUrl} target="blank">{wiki.title}</a></Title>
								{
									wiki.language === "en" ?
										<Col span={4} offset={20}>
											<Switch checkedChildren="中" unCheckedChildren="英" checked={transed} loading={loading} onClick={trans} size={'small'} />
										</Col> : ''
								}
								<Paragraph ellipsis={{ rows: 13 }} style={{ "textAlign": "left", "text-indent": "28px", "fontSize":'14px' }}>{transed ? transText : wiki.content}</Paragraph>
							</Col>
						</Row>						
					</TabPane> : ''
				}
			</Tabs>
		:''
	)
}

export default InfoCard;